import React, {useState, useEffect, useLayoutEffect} from 'react'
import { Routes, Route, useLocation, useNavigationType } from 'react-router-dom'
import { isMobile, isIOS, isAndroid } from 'react-device-detect';

import { Top } from "../features/top/Top";
import { List } from "../features/list/List";
import { Camera } from "../features/camera/Camera";
import { Fish } from "../features/fish/Fish";
import { DeviceLayout, PCDevice, IOSDevice, AndroidDevice } from '../features/device/DeviceLayout'

import commonDatas  from './CommonDatas'

export function AppRoutes() {
  const location = useLocation();
  const navType = useNavigationType();

  const [isDevicePC, setIsDevicePC] = useState(false);
  const [isDeviceWebView, setIsDeviceWebView] = useState(false);
  const [isDeviceIOS, setIsDeviceIOS] = useState(false);
  const [isDeviceAndroid, setIsDeviceAndroid] = useState(false);

  useLayoutEffect(() => {

    setIsDevicePC(!isMobile);
    setIsDeviceWebView(window.ua.WEB_VIEW);
    setIsDeviceIOS(isIOS);
    setIsDeviceAndroid(isAndroid);

  }, [setIsDevicePC, setIsDeviceIOS, setIsDeviceAndroid]);


  useEffect(() => {
    if( !commonDatas.isInited ){
      commonDatas.init();
    }
    if (navType === "PUSH") {
//      console.log("in" );
    }
  }, [location, navType]);


  if( !isDevicePC && !isDeviceWebView ){
    return (
      <>
          <Routes>
            <Route exact path="/" element={
              <Top></Top>
            }>
            </Route>

            <Route path="/list" element={
               <List></List>
            }>
            </Route>

            <Route path="/camera" element={
               <Camera></Camera>
            }>
            </Route>
            <Route path="/fish" element={
               <Fish></Fish>
            }>
            </Route>

            <Route path="*" element={<p>not found.</p>}></Route>
          </Routes>

      </>
    )
  }else{
    return (
      <>
        <DeviceLayout>
          {isDevicePC && <PCDevice></PCDevice>}
          {isDeviceIOS && <IOSDevice></IOSDevice>}
          {isDeviceAndroid && <AndroidDevice></AndroidDevice>}
        </DeviceLayout>
      </>
    )
  }
}